import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  level?: number | string;
  weight?: 'bold' | 'semibold' | 'medium' | 'normal';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiHeading.ts',
  props: {
    level: { default: 6 },
    weight: { default: 'normal' }
  },
  setup(__props: any) {

const props = __props as { level: number | string, weight: 'bold' | 'semibold' | 'medium' | 'normal' };



const component = computed<string>(() => `h${props.level}`);

return { __sfc: true,props, component }
}

})